import { render } from "./HamburgerMenuIcon.vue?vue&type=template&id=b774d9b0&scoped=true"
const script = {}

import "./HamburgerMenuIcon.vue?vue&type=style&index=0&id=b774d9b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b774d9b0"]])

export default __exports__